import React from "react"
import { Switch, Route, Redirect } from "react-router-dom"
import { getSuburls } from "./suburls"
import * as R from "ramda"
import { caseRequest } from "data/cockpit/api"

const Reports = ({
  match,
  caseId,
  refetchCase,
  case_,
  editId,
  setEditId,
  urls,
  routes,
}) => {
  const suburls = getSuburls(match)

  return (
    <Switch>
      {R.values(suburls)
        .filter(x => !x.disabled)
        .map(x => {
          const Component = x.component

          return (
            <Route
              key={x.path}
              path={x.path}
              render={p => (
                <Component
                  {...p}
                  caseUrls={suburls}
                  suburls={suburls}
                  caseId={caseId}
                  refetch={refetchCase}
                  case_={case_}
                  editId={editId}
                  setEditId={setEditId}
                  urls={urls}
                  fromCase
                  routes={routes}
                  listRequest={caseRequest.listConclusions}
                />
              )}
            />
          )
        })}
      <Redirect to={suburls.list.url} />
    </Switch>
  )
}

export default Reports
